import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/graficas`;

export async function obtenerDatosGraficas(userInfo = {}, filtros = {}) {
  try {
    const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;



    // 🔥 CONSTRUIR PARÁMETROS DE FILTROS
    const params = {};

    if (filtros.searchTerm) params.search = filtros.searchTerm;
    if (filtros.filterEstado && filtros.filterEstado !== 'todos') params.estado = filtros.filterEstado;
    if (filtros.filterMunicipio && filtros.filterMunicipio !== 'todos') params.municipioId = parseInt(filtros.filterMunicipio);
    if (filtros.filterDepartamento && filtros.filterDepartamento !== 'todos') params.departamentoId = parseInt(filtros.filterDepartamento);
    if (filtros.filterSexo && filtros.filterSexo !== 'todos') params.genero = filtros.filterSexo;
    const response = await axios.get(`${baseUrl}/`, {
      params,
      headers: {
        "x-usuario-id": usuarioId,
        "x-user-ip": ip,
        "x-usuario-municipio-id": usuarioMunicipioId?.toString() || "0",
        "x-usuario-es-admin": esAdmin?.toString() || "false"
      },
      timeout: 15000
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error fetching datos gráficas:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url
    });

    // 🔥 RETORNAR ESTRUCTURA CONSISTENTE EN CASO DE ERROR
    return {
      success: false,
      data: {
        estados: [],
        subestadosPorEstado: [],
        generos: [],
        departamentos: [],
        municipiosPorDepartamento: []
      },
      error: error.message
    };
  }
}